"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sotto-il-monte-giovanni-xxiii": {
    "3929e7f0": [{
      "hkey": "fb1ce635",
      "slug": "sotto-il-monte-giovanni-xxiii",
      "name": "Sotto il Monte Giovanni XXIII",
      "primary": true,
      "skipSearch": false
    }],
    "botta": [{
      "hkey": "fb1ce635",
      "slug": "sotto-il-monte-giovanni-xxiii",
      "name": "Sotto il Monte Giovanni XXIII",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c0e8d171": [{
      "hkey": "fb1ce635",
      "slug": "sotto-il-monte-giovanni-xxiii",
      "name": "Sotto il Monte Giovanni XXIII",
      "primary": true,
      "skipSearch": false
    }],
    "brusicco": [{
      "hkey": "fb1ce635",
      "slug": "sotto-il-monte-giovanni-xxiii",
      "name": "Sotto il Monte Giovanni XXIII",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;